import { FormikCheckbox } from "./FormikCheckbox";
import type { FieldOption } from "@repo/types";
import { useFormikContext } from "formik";

export interface FormikMultipleCheckboxesProps {
  name: string;
  value: (string | number)[] | undefined;
  label?: React.ReactNode;
  options?: FieldOption[];
  disabled?: boolean;
  error?: string;
}

export const FormikMultipleCheckboxes = ({
  value,
  error,
  ...props
}: FormikMultipleCheckboxesProps) => {
  const { setFieldValue } = useFormikContext();
  return (
    <div>
      {!!props.label && <p>{props.label}</p>}
      {props.options?.map((opt) => (
        <FormikCheckbox
          name={opt.value as string}
          key={opt.value}
          label={opt.label ?? ""}
          checked={!!value && (value as string[]).includes(opt.value as string)}
          onCheckedChange={(checked) => {
            value = (value ?? []).filter((v) => v !== opt.value);
            if (checked) {
              value.push(opt.value);
            }
            setFieldValue(props.name, value);
          }}
          orientation="horizontal"
          disabled={props.disabled}
        />
      ))}
      {!!error && <p className="text-destructive">{error}</p>}
    </div>
  );
};
